import api from "../../api";

const state = {
  projects: null,
  biddingUrl: null
};

const getters = {
  getBiddingId: state => {
    const id = state.biddingUrl.split("/");
    return id[id.length - 1];
  }
};

const mutations = {
  set_biddingUrl(state, data) {
    state.biddingUrl = data.biddingUrl;
  }
};

const actions = {
  postBidding({ commit, rootGetters }, data) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `projects/${data.projectId}/biddings`,
        method: "POST",
        withCredentials: true,
        data: data.bidding,
        headers: {
          Authorization: rootGetters.authToken
        }
      })
        .then(resp => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch(err => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },

  updateBidding({ commit, rootGetters }, data) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `projects/${data.projectId}/biddings/${data.bidding.ID}`,
        method: "PUT",
        withCredentials: true,
        data: data.bidding,
        headers: {
          Authorization: rootGetters.authToken
        }
      })
        .then(resp => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch(err => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },

  getBidding({ commit, rootGetters }, data) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `/projects/${data.projectId}/biddings`,
        method: "GET",
        headers: {
          Authorization: rootGetters.authToken
        }
      })
        .then(resp => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch(err => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },

  getBiddings({ commit, rootGetters }, data) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `projects/${data.projectId}/biddings`,
        method: "GET",
        headers: {
          Authorization: rootGetters.authToken
        }
      })
        .then(resp => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch(err => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  }
};

export const biddings = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
